import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { getStudentDossier, type StudentDossier } from "@/services/studentService";

/** Charge le dossier complet de l'élève à l'ouverture d'une fenêtre (null pendant le chargement). */
export function useStudentDossier(studentId: string | null, open: boolean) {
  const { can } = useAuth();
  const allowed = can("dossiers:read");
  const [dossier, setDossier] = useState<StudentDossier | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setDossier(null);
    setError(null);
    if (!open || !studentId) return;
    if (!allowed) {
      setError("Responsables, historique et frais : réservés aux rôles ayant accès aux dossiers des élèves.");
      return;
    }
    let cancelled = false;
    getStudentDossier(studentId)
      .then((d) => !cancelled && setDossier(d))
      .catch((err) => !cancelled && setError(err instanceof Error ? err.message : "Dossier indisponible."));
    return () => {
      cancelled = true;
    };
  }, [studentId, open, allowed]);

  return { dossier, error };
}
